import {
  REPLENISHMENT_PLAN_FETCH,
  REPLENISHMENT_PLAN_RECEIVED,
  REPLENISHMENT_PLAN_ERROR,
  REPLENISHMENT_PLAN_UPDATE_ERROR,
  REPLENISHMENT_PLAN_CLEAR_ERROR,
} from '../actions/replenishPlan';

const initialState = {
  fetching: false,
  plan: undefined,
  id: undefined,
  error: '',
};

const replenishPlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPLENISHMENT_PLAN_FETCH:
      return {
        ...state,
        fetching: true,
      };
    case REPLENISHMENT_PLAN_RECEIVED:
      return {
        ...state,
        fetching: false,
        id: action.id,
        plan: action.plan,
        planogram: action.planogram,
        planogramImageUrl: action.planogramImageUrl,
      };
    case REPLENISHMENT_PLAN_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case REPLENISHMENT_PLAN_UPDATE_ERROR:
      return {
        ...state,
        fetching: false,
        error: action.error,
      };
    case REPLENISHMENT_PLAN_CLEAR_ERROR:
      return {
        ...state,
        error: '',
        fetching: false,
      };
    default:
      return state;
  }
};

export default replenishPlanReducer;
